// extracted by mini-css-extract-plugin
export default {"NavPane":"ArtifactRegistryIndex-module__NavPane__fQBEzTV"};